angular.module('impactx.rfx').controller('RFXSupportCtrl', [
    '$routeParams',
    'dataGen',
    'DownloadService',
    'ToolbarService',
    RFXSupportCtrl
]);

function RFXSupportCtrl($routeParams, dataGen, DownloadService, ToolbarService) {
    var self = this;
    self.id = $routeParams.rfqhId || 0;
    self.selectedPositions = [];

    getData();

    function getData() {
        return dataGen.getData(self, {rfqhId: self.id}, '/rfx/support/view').then(function () {
            defineButtons();
        });
    }

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    self.getConversationsLink = function () {
        return 'rfxthread/support/' + self.id;
    };

    self.allowConversations = function () {
        return impactX.isDefined(self, 'data.allowConversations');
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: self.trns.conversations,
                linkFunction: self.getConversationsLink,
                type: 'link',
                condition: self.allowConversations
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}